import React from 'react'

/**
 * A simple title component that only
 * returns a heading if one is passed in.
 */
export default function Title({ heading }) {
  return heading ? <h1>{heading}</h1> : null
}
